import { LoadunitDto } from '../../shared/generated/backend';
import { LoadUnitSlot } from '../../shared/planning/loadunitSlot';

export class LoadUnitSlots extends Array<LoadUnitSlot | null> {
  // Get truck (element 0 or null)
  get truck(): LoadUnitSlot | null {
    return this[0] ?? null;
  }

  // Get trailer (element 1 or null)
  get trailer(): LoadUnitSlot | null {
    return this[1] ?? null;
  }

  syncWith(usedLoadUnits: LoadunitDto[]): void {
    [0, 1].forEach(index => {
      if (usedLoadUnits[index])
        if (this[index])
          this[index]!.loadUnitContainer = usedLoadUnits[index]; // update container
        else this[index] = new LoadUnitSlot(usedLoadUnits[index]);
      // new loadunit
      else if (this[index]) this.splice(index, 1); // remove loadunit if not in usedloadUnits
    });
  }
}
